<template>
  <div class="explore-filters" :class="{ 'has-clear': hasActiveFilters }" :style="filterStyle">

    <div class="mobile-nav-trail d-flex align-items-center">
    <div class="d-flex filter-container" ref="filterScroll">
      <div class="filter-bar">
        <button
          type="button"
          class="btn dropbtn d-flex align-items-center source-toggle-btn"
          @click="toggleDropdown('sourceDropdown', $event)"
        >
          <span class="material-icons source-toggle-icon">{{ activeSourceIcon }}</span>
          <!-- <small>{{ activeSourceLabel }}</small> -->
          <span class="material-icons ml-1" style="pointer-events: none">arrow_drop_down</span>
        </button>

        <template v-if="isHikesSource">

        <button type="button" :class=" $store.getters['exploreV2/hasDistanceFilter'] ? 'btn dropbtn d-flex align-items-center active' : 'btn dropbtn d-flex align-items-center'" @click="toggleDropdown('distanceDropdown', $event)">
          <small>Distance</small> <span class="material-icons ml-1" style="pointer-events: none">arrow_drop_down</span>
        </button>

        <button type="button" :class=" $store.getters['exploreV2/hasElevationsFilter'] ? 'btn dropbtn d-flex align-items-center active' : 'btn dropbtn d-flex align-items-center'" @click="toggleDropdown('elevationDropdown', $event)">
          <small>Elevation</small> <span class="material-icons ml-1" style="pointer-events: none">arrow_drop_down</span>
        </button>

        <button type="button" :class=" $store.getters['exploreV2/hasDifficultyFilter'] ? 'btn dropbtn d-flex align-items-center active' : 'btn dropbtn d-flex align-items-center'" @click="toggleDropdown('difficultyDropdown', $event)">
          <small>Difficulty</small> <span class="material-icons ml-1" style="pointer-events: none">arrow_drop_down</span>
        </button>

        <button type="button" :class=" $store.getters['exploreV2/hasSelectedActivityTags'] ? 'btn dropbtn d-flex align-items-center active' : 'btn dropbtn d-flex align-items-center'" @click="toggleDropdown('activityTagsDropdown', $event)">
          <small>Activities</small> <span class="material-icons ml-1" style="pointer-events: none">arrow_drop_down</span>
        </button>

        <button type="button" :class=" $store.getters['exploreV2/hasSelectedFeatureTags'] ? 'btn dropbtn d-flex align-items-center active' : 'btn dropbtn d-flex align-items-center'" @click="toggleDropdown('featureTagsDropdown', $event)">
          <small>Features</small> <span class="material-icons ml-1" style="pointer-events: none">arrow_drop_down</span>
        </button>

        <button type="button" :class="activeRatingCount !== 0 ? 'btn dropbtn d-flex align-items-center active' : 'btn dropbtn d-flex align-items-center'" @click="toggleDropdown('ratingDropdown', $event)">
          <small>Rating</small> <span class="material-icons ml-1" style="pointer-events: none">arrow_drop_down</span>
        </button>

        <button type="button" :class="$store.getters['exploreV2/hasDurationFilter'] ? 'btn dropbtn d-flex align-items-center active' : 'btn dropbtn d-flex align-items-center'" @click="toggleDropdown('durationDropdown', $event)">
          <small>Duration</small> <span class="material-icons ml-1" style="pointer-events: none">arrow_drop_down</span>
        </button>

        <button type="button" :class="$store.getters['exploreV2/hasTrailGeometryTypeFilter'] ? 'btn dropbtn d-flex align-items-center active' : 'btn dropbtn d-flex align-items-center'" @click="toggleDropdown('trailTypeDropdown', $event)">
          <small>Type</small> <span class="material-icons ml-1" style="pointer-events: none">arrow_drop_down</span>
        </button>

        <button
          v-if="hasActiveFilters"
          type="button"
          class="btn btn-link text-warning clear-filters-btn d-flex align-items-center"
          @click="clearAllFilter"
        >
          <span class="material-icons mr-1" style="font-size:18px;">close</span>
          <small>Clear</small>
        </button>
        </template>

        <template v-else>
          <button type="button" :class=" $store.getters['exploreV2/hasDistanceFilter'] ? 'btn dropbtn d-flex align-items-center active' : 'btn dropbtn d-flex align-items-center'" @click="toggleDropdown('distanceDropdown', $event)">
            <small>Distance</small> <span class="material-icons ml-1" style="pointer-events: none">arrow_drop_down</span>
          </button>

          <button type="button" :class=" $store.getters['exploreV2/hasCommunityDurationFilter'] ? 'btn dropbtn d-flex align-items-center active' : 'btn dropbtn d-flex align-items-center'" @click="toggleDropdown('communityDurationDropdown', $event)">
            <small>Duration</small> <span class="material-icons ml-1" style="pointer-events: none">arrow_drop_down</span>
          </button>

          <button type="button" :class=" $store.getters['exploreV2/hasCommunityElevationFilter'] ? 'btn dropbtn d-flex align-items-center active' : 'btn dropbtn d-flex align-items-center'" @click="toggleDropdown('communityElevationDropdown', $event)">
            <small>Elevation</small> <span class="material-icons ml-1" style="pointer-events: none">arrow_drop_down</span>
          </button>

          <button type="button" :class=" $store.getters['exploreV2/hasSelectedCommunityItemTypes'] ? 'btn dropbtn d-flex align-items-center active' : 'btn dropbtn d-flex align-items-center'" @click="toggleDropdown('communityTypeDropdown', $event)">
            <small>Type</small> <span class="material-icons ml-1" style="pointer-events: none">arrow_drop_down</span>
          </button>

          <button
            v-if="hasActiveFilters"
            type="button"
            class="btn btn-link text-warning clear-filters-btn d-flex align-items-center"
            @click="clearAllFilter"
          >
            <span class="material-icons mr-1" style="font-size:18px;">close</span>
            <small>Clear</small>
          </button>
        </template>
      </div>
    </div>
    <transition name="fade">
      <div class="filter-scroll-indicator" v-if="showScrollHint">
        <span class="material-icons">chevron_right</span>
      </div>
    </transition>
  </div>

    <div class="dropdown-content p-2 sourceDropdown" id="source-dropdown">
      <button
        type="button"
        class="btn source-dropdown-option w-100 d-flex align-items-center justify-content-between"
        :class="{ active: isHikesSource }"
        @click="setSearchSource('hikes')"
      >
        <span class="d-flex align-items-center">
          <span class="material-icons mr-2">star</span>
          <span>Official</span>
        </span>
        <span v-if="isHikesSource" class="material-icons">check</span>
      </button>

      <button
        type="button"
        class="btn source-dropdown-option w-100 d-flex align-items-center justify-content-between"
        :class="{ active: !isHikesSource }"
        @click="setSearchSource('community')"
      >
        <span class="d-flex align-items-center">
          <span class="material-icons mr-2">groups</span>
          <span>Community</span>
        </span>
        <span v-if="!isHikesSource" class="material-icons">check</span>
      </button>
    </div>

    <div class="dropdown-content p-3 communityTypeDropdown" id="community-type-dropdown">
      <label class="checkbox-container">
        <p class="m-0">Hikes</p>
        <input type="checkbox" @click="communityTypeClicked('Hike')" :checked="selectedCommunityItemTypes.includes('Hike')">
        <span class="checkmark"></span>
      </label>
      <hr class="my-2">
      <label class="checkbox-container">
        <p class="m-0">Recordings</p>
        <input type="checkbox" @click="communityTypeClicked('Recording')" :checked="selectedCommunityItemTypes.includes('Recording')">
        <span class="checkmark"></span>
      </label>
      <hr class="mt-2 mb-3">
      <p class="text-center p-0 m-0"><button class="btn p-0 m-0" @click="clearCommunityTypes">Clear</button></p>
    </div>

    <div class="dropdown-content p-3 communityDurationDropdown" id="community-duration-dropdown">
      <template v-if="communityDurationRangeHours[1] >= 24">
        <p>Min: {{ formatDurationHours(communityDurationRangeHours[0]) }} - Max: {{ formatDurationHours(communityDurationRangeHours[1]) }}+</p>
      </template>
      <template v-else>
        <p>Min: {{ formatDurationHours(communityDurationRangeHours[0]) }} - Max: {{ formatDurationHours(communityDurationRangeHours[1]) }}</p>
      </template>
      <div>
        <vue-slider :min="0" :max="24" :interval="0.5" class="pt-3 pb-3" v-model="communityDurationRangeHours">
          <template #tooltip="{ value }">
            {{ formatDurationHours(value) }}
          </template>
        </vue-slider>
      </div>
      <hr>
      <p class="text-center p-0 m-0"><button class="btn p-0 m-0" @click="clearCommunityDuration">Clear</button></p>
    </div>

    <div class="dropdown-content p-3 communityElevationDropdown" id="community-elevation-dropdown">
      <template v-if="communityElevationRangeMeters[1] >= 2500">
        <p>Min Gain: {{ Math.round(communityElevationRangeMeters[0]) }}m - Max Gain: {{ Math.round(communityElevationRangeMeters[1]) }}m+</p>
      </template>
      <template v-else>
        <p>Min Gain: {{ Math.round(communityElevationRangeMeters[0]) }}m - Max Gain: {{ Math.round(communityElevationRangeMeters[1]) }}m</p>
      </template>
      <div>
        <vue-slider :min="0" :max="2500" :interval="50" class="pt-3 pb-3" v-model="communityElevationRangeMeters">
          <template #tooltip="{ value }">
            {{ Math.round(value) }}m
          </template>
        </vue-slider>
      </div>
      <hr>
      <p class="text-center p-0 m-0"><button class="btn p-0 m-0" @click="clearCommunityElevation">Clear</button></p>
    </div>

    <!-- FILTER POP UPS -->
    <div class="dropdown-content distanceDropdown p-3">
      <template v-if="filterDistanceRange[1] > 149">
        <p>Min Dist: {{filterDistanceRange[0] + currentBigUnitSymbol}} - Max Dist: {{filterDistanceRange[1] + currentBigUnitSymbol}}+</p>
      </template>
      <template v-else>
        <p>Min Dist: {{filterDistanceRange[0] + currentBigUnitSymbol}} - Max Dist: {{filterDistanceRange[1] + currentBigUnitSymbol}}</p>
      </template>
      <div>
        <vue-slider :min="0" :max="150"  class="pt-3 pb-3" ref="slider" v-model="filterDistanceRange">
          <template #tooltip="{ value }">
            {{value}}km
          </template>
        </vue-slider>
      </div>
      <hr>
      <p class="text-center p-0 m-0"><button class="btn p-0 m-0" @click="clearMaxDistance">Clear</button></p>
    </div>

    <div class="dropdown-content p-3 elevationDropdown" id="elevation-dropdown">
      <div class="form-check">
        <label class="checkbox-container">
          <p class="m-0">Low</p>
          <small class="text-muted">Generally flat or downhill</small>
          <input type="checkbox" @click="elevationClicked('Easy')">
          <span class="checkmark"></span>
        </label>
      </div>
      <hr class="my-2">
      <div class="form-check">
        <label class="checkbox-container">
          <p class="m-0">Medium</p>
          <small class="text-muted">Hilly in places</small>
          <input type="checkbox" @click="elevationClicked('Medium')">
          <span class="checkmark"></span>
        </label>
      </div>
      <hr class="my-2">
      <div class="form-check">
        <label class="checkbox-container">
          <p class="m-0">High</p>
          <small class="text-muted">Steep and challenging</small>
          <input type="checkbox" @click="elevationClicked('Difficult')">
          <span class="checkmark"></span>
        </label>
      </div>
      <hr class="mt-2 mb-3">
      <p class="text-center p-0 m-0"><button class="btn p-0 m-0" @click="elevationCleared">Clear</button></p>
    </div>

    <div class="dropdown-content p-3 difficultyDropdown" id="difficulty-dropdown">
      <div class="form-check">
        <label class="checkbox-container">
          <p class="m-0">Easy</p>
          <input type="checkbox" @click="difficultyClicked('Easy')" :checked="difficulties.includes('Easy')">
          <span class="checkmark"></span>
        </label>
      </div>
      <hr class="my-2">
      <div class="form-check">
        <label class="checkbox-container">
          <p class="m-0">Medium</p>
          <input type="checkbox" @click="difficultyClicked('Medium')">
          <span class="checkmark"></span>
        </label>
      </div>
      <hr class="my-2">
      <div class="form-check">
        <label class="checkbox-container">
          <p class="m-0">Difficult</p>
          <input type="checkbox" @click="difficultyClicked('Difficult')">
          <span class="checkmark"></span>
        </label>
      </div>
      <hr class="my-2">
      <div class="form-check">
        <label class="checkbox-container">
          <p class="m-0">Extra Difficult</p>
          <input type="checkbox" @click="difficultyClicked('Extra Difficult')">
          <span class="checkmark"></span>
        </label>
      </div>
      <hr class="mt-2 mb-3">
      <p class="text-center p-0 m-0"><button class="btn p-0 m-0" @click="difficultyCleared">Clear</button></p>
    </div>

    <div class="dropdown-content p-3 activityTagsDropdown" id="activity-tags-dropdown">
      <span class="badge badge-secondary badge-filter mb-1 active" v-for="tag in activeActivityTags" :key="tag" @click="activeActivityTagClicked(tag)">{{tag}}</span>
      <span class="badge badge-secondary badge-filter mb-1" v-for="tag in inactiveActivityTags" :key="tag" @click="inactiveActivityTagClicked(tag)">{{tag}}</span>
      <hr>
      <p class="text-center p-0 m-0"><button class="btn p-0 m-0" @click="clearActivityTags"> Clear</button></p>
    </div>

    <div class="dropdown-content p-3 featureTagsDropdown" id="feature-tags-dropdown">
      <span class="badge badge-secondary badge-filter mb-1 active" v-for="tag in activeFeatureTags" :key="tag" @click="activeFeatureTagClicked(tag)">{{tag}}</span>
      <span class="badge badge-secondary badge-filter mb-1" v-for="tag in inactiveFeatureTags" :key="tag" @click="inactiveFeatureTagClicked(tag)">{{tag}}</span>
      <hr>
      <p class="text-center p-0 m-0"><button class="btn p-0 m-0" @click="clearFeatureTags"> Clear</button></p>
    </div>

    <div class="dropdown-content p-3 ratingDropdown" id="rating-dropdown">
      <p class="rating d-flex align-items-center">
        <button v-for="i in activeRatingCount" :key="'active-' + i" class="btn p-0 m-0" @click="setRating(i)"><span class="material-icons" style="color:#FFCD16;">star</span></button>
        <button v-for="i in inactiveRatingCount" :key="'inactive-' + i" class="btn p-0 m-0" @click="setRating(activeRatingCount + i)"><span class="material-icons" style="color:#888;">star_border</span></button>
      </p>
      <small class="text-muted">and above</small>
      <hr>
      <p class="text-center p-0 m-0"><button class="btn p-0 m-0" @click="clearRating">Clear</button></p>
    </div>

    <div class="dropdown-content p-3 durationDropdown" id="duration-dropdown">
      <template v-if="filterDurationRange[1] >= 24">
        <p>Min: {{ formatDurationHours(filterDurationRange[0]) }} - Max: {{ formatDurationHours(filterDurationRange[1]) }}+</p>
      </template>
      <template v-else>
        <p>Min: {{ formatDurationHours(filterDurationRange[0]) }} - Max: {{ formatDurationHours(filterDurationRange[1]) }}</p>
      </template>
      <div>
        <vue-slider :min="0" :max="24" :interval="0.5" class="pt-3 pb-3" v-model="filterDurationRange">
          <template #tooltip="{ value }">
            {{ formatDurationHours(value) }}
          </template>
        </vue-slider>
      </div>
      <hr>
      <p class="text-center p-0 m-0"><button class="btn p-0 m-0" @click="clearDuration">Clear</button></p>
    </div>

    <div class="dropdown-content p-3 trailTypeDropdown" id="trail-type-dropdown">
      <label class="checkbox-container">
        <p class="m-0">Loop</p>
        <input type="checkbox" @click="trailGeometryTypeClicked('loop')" :checked="selectedTrailGeometryTypes.includes('loop')">
        <span class="checkmark"></span>
      </label>
      <hr class="my-2">
      <label class="checkbox-container">
        <p class="m-0">Out and Back</p>
        <input type="checkbox" @click="trailGeometryTypeClicked('out_and_back')" :checked="selectedTrailGeometryTypes.includes('out_and_back')">
        <span class="checkmark"></span>
      </label>
      <hr class="my-2">
      <label class="checkbox-container">
        <p class="m-0">Point to Point</p>
        <input type="checkbox" @click="trailGeometryTypeClicked('point_to_point')" :checked="selectedTrailGeometryTypes.includes('point_to_point')">
        <span class="checkmark"></span>
      </label>
      <hr class="my-2">
      <label class="checkbox-container">
        <p class="m-0">Multi-Day</p>
        <input type="checkbox" @click="trailGeometryTypeClicked('multi_day')" :checked="selectedTrailGeometryTypes.includes('multi_day')">
        <span class="checkmark"></span>
      </label>
      <hr class="mt-2 mb-3">
      <p class="text-center p-0 m-0"><button class="btn p-0 m-0" @click="clearTrailGeometryTypes">Clear</button></p>
    </div>

  </div>
</template>

<script lang="ts">

import {defineComponent} from 'vue';
import axiosClient from '../../../utils/helpers/axios_client';
import {MeasurementPrefUtility} from '../../../utils/helpers/MeasurementPref';
import {Difficulty} from "../../../utils/models/TypesenseResponse";
import VueSlider from 'vue-slider-component'
import 'vue-slider-component/dist-css/vue-slider-component.css'
import { debounce } from 'lodash-es';
import graphClient from "../../../utils/graphql/graph_client";
import { GetAllHikeTags } from "../../../utils/graphql/hike-tags-graph";


export default defineComponent({
  components: {
    VueSlider
  },
  props: {
    sidebarCollapsed: {
      type: Boolean,
      default: false
    }
  },
  mounted() {
    this.handleResize();
    window.addEventListener('resize', this.handleResize);
    $('#difficulty-dropdown').on('click',function(e) {
      e.stopPropagation();
    });
    $('#elevation-dropdown').on('click',function(e) {
      e.stopPropagation();
     });
    $('#activity-tags-dropdown').on('click',function(e) {
      e.stopPropagation();
    });
    $('#feature-tags-dropdown').on('click',function(e) {
      e.stopPropagation();
    });
    $('#rating-dropdown').on('click',function(e) {
      e.stopPropagation();
    });
    $('#source-dropdown').on('click',function(e) {
      e.stopPropagation();
    });
    $('#community-type-dropdown').on('click',function(e) {
      e.stopPropagation();
    });
    $('#community-duration-dropdown').on('click',function(e) {
      e.stopPropagation();
    });
    $('#community-elevation-dropdown').on('click',function(e) {
      e.stopPropagation();
    });
    $('#duration-dropdown').on('click',function(e) {
      e.stopPropagation();
    });
    $('#trail-type-dropdown').on('click',function(e) {
      e.stopPropagation();
    });
    // Close the dropdown menu if the user clicks outside of it
    window.onclick = (event: MouseEvent) => {
      const target = event.target as HTMLElement | null;
      const clickedToggle = target?.closest('.dropbtn');
      if (clickedToggle) return;

      const dropdowns = document.getElementsByClassName('dropdown-content');
      let hadActive = false;
      for (let i = 0; i < dropdowns.length; i++) {
        const openDropdown = dropdowns[i] as HTMLElement;
        if (openDropdown.classList.contains('active')) {
          openDropdown.classList.remove('active');
          hadActive = true;
        }
      }
      if (hadActive) {
        window.dispatchEvent(new CustomEvent('explore-dropdown-active', { detail: false }));
      }
    };

    // Fetch all predefined hike tags via GraphQL
    graphClient.request(
      GetAllHikeTags
    ).then((response) => {
      console.log('GraphQL response:', response); // Debug log
      if (response && response.allHikeTags) {
        const { activityTags, featureTags } = response.allHikeTags;
        console.log('Activity tags:', activityTags);
        console.log('Feature tags:', featureTags);
        this.$store.commit('exploreV2/setActivityTags', activityTags || []);
        this.$store.commit('exploreV2/setFeatureTags', featureTags || []);
        
        // Also check if data was committed
        console.log('Store activity tags:', this.$store.state.exploreV2.activityTags);
        console.log('Store feature tags:', this.$store.state.exploreV2.featureTags);
      } else {
        console.error('Unexpected response structure:', response);
      }
    }).catch((error) => {
      console.error('Error fetching hike tags:', error);
      console.error('Error details:', error.response || error);
    });

    $('.continue').click(function () {
        $('.filter-container').animate({
            scrollLeft: '+=200'
        }, 500);
    });

    this.$nextTick(() => {
      this.setupScrollTracking();
    });
  },
  beforeUnmount() {
    window.removeEventListener('resize', this.handleResize);
    if (this.scrollContainer && this.scrollListener) {
      this.scrollContainer.removeEventListener('scroll', this.scrollListener);
    }
  },
  data() {
    return {
      filterDistanceRange: [0, 150],
      filterDurationRange: [0, 24],
      communityDurationRangeHours: [0, 24],
      communityElevationRangeMeters: [0, 2500],
      filterMinDistance: 0,
      difficulties: new Array<Difficulty>(),
      shouldRefreshChart: false,
      elevationDifficulties: new Array<Difficulty>(),
      newFilterRange: 10,
      viewportWidth: window.innerWidth,
      showScrollHint: false,
      scrollContainer: null as HTMLElement | null,
      scrollListener: null as (() => void) | null,
    }
  },
  watch: {
    filterDistanceRange: debounce(function (val) {
      this.$store.commit('exploreV2/setDistanceRangeMin', val[0]);
      this.$store.commit('exploreV2/setDistanceRangeMax', val[1]);
    }, 600),
    filterDurationRange: debounce(function (val) {
      this.$store.commit('exploreV2/setDurationRange', { min: val[0], max: val[1] >= 24 ? null : val[1] });
    }, 600),
    communityDurationRangeHours: debounce(function (val) {
      this.$store.commit('exploreV2/setCommunityDurationRangeMin', val[0]);
      this.$store.commit('exploreV2/setCommunityDurationRangeMax', val[1]);
    }, 600),
    communityElevationRangeMeters: debounce(function (val) {
      this.$store.commit('exploreV2/setCommunityElevationRangeMin', val[0]);
      this.$store.commit('exploreV2/setCommunityElevationRangeMax', val[1]);
    }, 600),
  },
  computed: {
    searchSource(): string {
      return this.$store.state.exploreV2.searchSource || 'hikes';
    },
    isHikesSource(): boolean {
      return this.searchSource === 'hikes';
    },
    activeSourceLabel(): string {
      return this.isHikesSource ? 'Official' : 'Community';
    },
    activeSourceIcon(): string {
      return this.isHikesSource ? 'verified' : 'groups';
    },
    filterStyle(): Record<string, string> {
      const mobileBreakpoint = 768;
      if (this.viewportWidth <= mobileBreakpoint) {
        return {
          left: '0.75rem',
          right: '0.75rem',
          transform: 'none',
          width: 'fit-content',
          maxWidth: 'calc(100vw - 1.5rem)'
        };
      }

      const sidebarOffset = this.sidebarCollapsed ? '1rem' : 'calc(320px + 2rem)';
      const maxWidth = this.sidebarCollapsed
        ? 'calc(100vw - 2rem)'
        : 'calc(100vw - 320px - 3rem)';

      return {
        left: sidebarOffset,
        transform: 'none',
        width: 'fit-content',
        maxWidth,
        right: 'auto'
      };
    },
    isMobileView(): boolean {
      return this.viewportWidth <= 768;
    },
    currentBigUnitSymbol() {
      const measurementPref = MeasurementPrefUtility.preference();
      return measurementPref.kilometerSymbol();
    },
    hasActiveFilters(): boolean {
      return this.$store.getters['exploreV2/hasfilter'];
    },
    activeRatingCount() {
      return this.$store.state.exploreV2.selectedMinRating ?? 0;
    },
    inactiveRatingCount() {
      return 5 - this.activeRatingCount;
    },
    activeActivityTags() {
      return this.$store.state.exploreV2.selectedActivityTags?.slice().reverse() || []
    },
    inactiveActivityTags() {
      return this.$store.state.exploreV2.activityTags?.filter(tag => !this.activeActivityTags.includes(tag)) || []
    },
    activeFeatureTags() {
      return this.$store.state.exploreV2.selectedFeatureTags?.slice().reverse() || []
    },
    inactiveFeatureTags() {
      return this.$store.state.exploreV2.featureTags?.filter(tag => !this.activeFeatureTags.includes(tag)) || []
    },
    selectedCommunityItemTypes(): string[] {
      return this.$store.state.exploreV2.selectedCommunityItemTypes || []
    },
    selectedTrailGeometryTypes(): string[] {
      return this.$store.state.exploreV2.selectedTrailGeometryTypes || []
    },
  },
  methods: {
    setSearchSource(source: 'hikes' | 'community') {
      if (this.searchSource === source) return;

      $('.dropdown-content.active').removeClass("active");
      this.$store.commit('exploreV2/setSearchSource', source);
      this.$store.commit('exploreV2/setTrail', null);
      this.$store.commit('exploreV2/setTrailEncodedPolyline', null);
      this.queueScrollHintUpdate();
    },
    handleResize() {
      this.viewportWidth = window.innerWidth;
      this.$nextTick(() => {
        this.updateScrollHint();
      });
    },
    setupScrollTracking() {
      if (this.scrollContainer && this.scrollListener) {
        this.scrollContainer.removeEventListener('scroll', this.scrollListener);
      }
      const container = (this.$el as HTMLElement).querySelector('.filter-container') as HTMLElement | null;
      if (!container) return;

      this.scrollContainer = container;
      const listener = () => {
        this.updateScrollHint();
      };
      this.scrollListener = listener;
      container.addEventListener('scroll', listener, { passive: true });
      this.updateScrollHint();
    },
    updateScrollHint() {
      const container = this.scrollContainer;
      if (!container) {
        this.showScrollHint = false;
        return;
      }
      const hasOverflow = container.scrollWidth > container.clientWidth + 2;
      const notAtEnd = container.scrollLeft < (container.scrollWidth - container.clientWidth - 8);
      this.showScrollHint = this.isMobileView && hasOverflow && notAtEnd;
    },
    queueScrollHintUpdate() {
      this.$nextTick(() => this.updateScrollHint());
    },
    formatDurationHours(value: number) {
      if (Number.isInteger(value)) {
        return `${value}h`;
      }
      return `${value.toFixed(1)}h`;
    },
    clearRating() {
      this.$store.commit('exploreV2/clearRating');
    },
    setRating(rating: number) {
      this.$store.commit('exploreV2/setRating', rating);
    },
    clearActivityTags() {
      this.$store.commit('exploreV2/setSelectedActivityTags', [])
      this.queueScrollHintUpdate();
    },
    clearFeatureTags() {
      this.$store.commit('exploreV2/setSelectedFeatureTags', [])
      this.queueScrollHintUpdate();
    },
    clearCommunityTypes() {
      this.$store.commit('exploreV2/setSelectedCommunityItemTypes', [])
      this.queueScrollHintUpdate();
    },
    clearDuration() {
      this.filterDurationRange = [0, 24]
      this.$store.commit('exploreV2/setDurationRange', { min: 0, max: null })
      this.queueScrollHintUpdate();
    },
    trailGeometryTypeClicked(type: string) {
      if (this.selectedTrailGeometryTypes.includes(type)) {
        this.$store.commit('exploreV2/removeTrailGeometryType', type)
      } else {
        this.$store.commit('exploreV2/addTrailGeometryType', type)
      }
      this.queueScrollHintUpdate();
    },
    clearTrailGeometryTypes() {
      this.$store.commit('exploreV2/setSelectedTrailGeometryTypes', [])
      this.queueScrollHintUpdate();
    },
    clearCommunityDuration() {
      this.communityDurationRangeHours = [0, 24]
      this.$store.commit('exploreV2/setCommunityDurationRangeMin', 0)
      this.$store.commit('exploreV2/setCommunityDurationRangeMax', 24)
      this.queueScrollHintUpdate();
    },
    clearCommunityElevation() {
      this.communityElevationRangeMeters = [0, 2500]
      this.$store.commit('exploreV2/setCommunityElevationRangeMin', 0)
      this.$store.commit('exploreV2/setCommunityElevationRangeMax', 2500)
      this.queueScrollHintUpdate();
    },
    communityTypeClicked(itemType: string) {
      if (this.selectedCommunityItemTypes.includes(itemType)) {
        this.$store.commit('exploreV2/removeCommunityItemType', itemType)
      } else {
        this.$store.commit('exploreV2/addCommunityItemType', itemType)
      }
      this.queueScrollHintUpdate();
    },
    activeActivityTagClicked(tag: string) {
      this.$store.commit('exploreV2/removeActivityTag', tag)
      this.queueScrollHintUpdate();
    },
    inactiveActivityTagClicked(tag: string) {
      this.$store.commit('exploreV2/addActivityTag', tag)
      this.queueScrollHintUpdate();
    },
    activeFeatureTagClicked(tag: string) {
      this.$store.commit('exploreV2/removeFeatureTag', tag)
      this.queueScrollHintUpdate();
    },
    inactiveFeatureTagClicked(tag: string) {
      this.$store.commit('exploreV2/addFeatureTag', tag)
      this.queueScrollHintUpdate();
    },
    difficultyClicked(difficulty: string) {
      const castDifficulty = Difficulty.fromString(difficulty)
      this.difficulties.includes(castDifficulty) ? this.difficulties.splice(
        this.difficulties.indexOf(castDifficulty), 1
      ) : this.difficulties.push(castDifficulty)
      this.$store.commit('exploreV2/setDifficulties', this.difficulties);
      this.queueScrollHintUpdate();
    },
    difficultyCleared() {
      this.difficulties = []
      this.$store.commit('exploreV2/setDifficulties', this.difficulties);
      this.disableAllChecksForId('difficulty-dropdown');
      this.queueScrollHintUpdate();
    },
    elevationClicked(elevationDifficulty: string) {
      const castDifficulty = Difficulty.fromString(elevationDifficulty)
      if (castDifficulty == Difficulty.Difficult) {
        this.elevationDifficulties.includes(Difficulty.ExtraDifficult) ? this.elevationDifficulties.splice(
          this.elevationDifficulties.indexOf(Difficulty.ExtraDifficult), 1
        ) : this.elevationDifficulties.push(Difficulty.ExtraDifficult)
      }
      this.elevationDifficulties.includes(castDifficulty) ? this.elevationDifficulties.splice(
        this.elevationDifficulties.indexOf(castDifficulty), 1
      ) : this.elevationDifficulties.push(castDifficulty)
      this.$store.commit('exploreV2/setElevations', this.elevationDifficulties);
      this.queueScrollHintUpdate();
    },
    elevationCleared() {
      this.elevationDifficulties = []
      this.$store.commit('exploreV2/setElevations', this.elevationDifficulties);
      this.disableAllChecksForId('elevation-dropdown');
      this.queueScrollHintUpdate();
    },
    disableAllChecksForId(id: string) {
      $(`#${id} input[type=checkbox]`).prop('checked', false);
    },
  clearAllFilter(){
    this.elevationCleared()
    this.difficultyCleared()
    this.clearActivityTags()
    this.clearFeatureTags()
    this.clearCommunityTypes()
    this.clearCommunityDuration()
    this.clearCommunityElevation()
    this.clearRating()
    this.clearDuration()
    this.clearTrailGeometryTypes()
    this.$store.commit('exploreV2/setSelectedTrailTags', [])
    this.$store.commit('exploreV2/setDistanceRangeMin', 0)
    this.$store.commit('exploreV2/setDistanceRangeMax', 150)
    this.clearMaxDistance()
    this.queueScrollHintUpdate();
  },
    clearMaxDistance() {
      this.filterDistanceRange = [0, 150]
      this.queueScrollHintUpdate();
    },
    toggleDropdown(modal: string, event?: MouseEvent){
      const currentTarget = $('.' + modal)
      $('.dropdown-content.active').not(currentTarget).removeClass("active");
      currentTarget.toggleClass("active");

      if (event && currentTarget.hasClass('active')) {
        const btn = (event.currentTarget as HTMLElement);
        const filtersEl = this.$el as HTMLElement;
        const btnRect = btn.getBoundingClientRect();
        const filtersRect = filtersEl.getBoundingClientRect();
        const leftOffset = btnRect.left - filtersRect.left;
        const dropdownWidth = currentTarget.outerWidth() || 300;
        const maxLeft = filtersRect.width - dropdownWidth;
        const clampedLeft = Math.max(0, Math.min(leftOffset, maxLeft));
        currentTarget.css('left', clampedLeft + 'px');
      }

      this.$nextTick(() => {
        this.updateScrollHint();
        const anyActive = document.querySelectorAll('.dropdown-content.active').length > 0;
        window.dispatchEvent(new CustomEvent('explore-dropdown-active', { detail: anyActive }));
      });
    },
    handleSpanClick(e: any) {
      e.stopPropagation();
    },
  }
});
</script>

<style>

.explore-filters {
  position: absolute;
  top: 1rem;
  z-index: 600;
  display: flex;
  flex-direction: column;
  align-items: stretch;
  pointer-events: auto;
  overflow: visible;
  z-index: 10000;
}

.mobile-nav-trail {
  background: rgba(27, 27, 29, 0.92);
  border-radius: 999px;
  box-shadow: 0 8px 24px rgba(0, 0, 0, 0.4);
  padding: 0.18rem 0.65rem;
  gap: 0.5rem;
  min-height: 0;
  justify-content: center;
  width: 100%;
  position: relative;
}

.mobile-nav-trail::after {
  content: '';
  position: absolute;
  top: 0;
  right: 0;
  width: 50px;
  height: 100%;
  pointer-events: none;
  opacity: 1;
  border-radius: inherit;
  z-index: 1;
}

.mobile-nav-trail .continue {
  color: rgba(255, 255, 255, 0.55);
  margin-left: 0.5rem;
}

.explore-filters .filter-container {
  width: 100%;
  max-width: 100%;
  overflow-x: auto;
}

.filter-bar{
  display: inline-flex;
  width: auto;
  justify-content: flex-start;
  flex-wrap: nowrap;
  gap: 0.5rem;
}
.clear-filters-btn {
  color: #fddf00 !important;
  padding: 0 0.5rem;
  background: transparent;
  border: none;
  text-decoration: none;
  transition: color 0.15s ease;
}
.clear-filters-btn:hover {
  color: #ffe866 !important;
  text-decoration: none;
}
.explore-filters.has-clear .filter-bar {
  gap: 0.35rem;
}
.explore-filters.has-clear .clear-filters-btn {
  margin-left: auto;
}

.filter-container::-webkit-scrollbar {
  display: none;  /* Safari and Chrome */
}
.filter-container{
  display: flex;
  align-items: center;
  overflow-x: auto;
  overflow-y: visible;
  -ms-overflow-style: none;
  scrollbar-width: none;
  justify-content: flex-start;
  position: relative;
}

.filter-scroll-indicator {
  position: absolute;
  top: 50%;
  right: 0.5rem;
  transform: translateY(-50%);
  display: flex;
  align-items: center;
  justify-content: center;
  width: 1.6rem;
  height: 1.6rem;
  border-radius: 50%;
  background: rgba(0, 0, 0, 0.45);
  color: rgba(255, 255, 255, 0.8);
  pointer-events: none;
  z-index: 10;
}

.filter-scroll-indicator .material-icons {
  font-size: 1.1rem;
}

.fade-enter-active, .fade-leave-active {
  transition: opacity 0.3s ease;
}

.fade-enter-from, .fade-leave-to {
  opacity: 0;
}

.filter-bar .btn{
  font-weight: 400;
  font-size: 1em;
  margin: .5em 0;
  padding: .5em .75em;
  white-space: nowrap;
  flex: 0 0 auto;
  height: auto !important;
}

.filter-bar .btn.active{
  background-color: #2c2c2c;
}

.source-toggle-icon {
  font-size: 1.5rem;
  color: var(--yellow);
}

.source-dropdown-option {
  color: #fff;
  text-align: left;
  border-radius: 8px;
  margin: 0.1rem 0;
  border: 1px solid transparent;
}

.source-dropdown-option .material-icons {
  font-size: 1.05rem;
}

.source-dropdown-option.active {
  background: rgba(255, 223, 0, 0.15);
  border-color: rgba(255, 223, 0, 0.35);
  color: #ffdf00;
}

.source-dropdown-option:hover {
  background: rgba(255, 255, 255, 0.08);
}

.filter-bar .dropdown-toggle::after{
  margin-left: 0.7em;
}

.filter-bar .dropdown-menu{
  background-color: #17181d;
}

.badge-filter{
  padding: 0.6em 1em;
  font-size: .875em;
  margin: 0.1em;
  background-color: #2c2c2c;
  color: #fff;
  font-weight: 500;
  cursor: pointer;
}

.badge-filter:hover{
  opacity: .8;
}

.badge-filter.active{
  background-color: #464545;
}

.form-check{
  padding-left: 0;
}
.form-check-input{
  position: static;
  float: right;
}

.rating span.active{
  color: var(--yellow);
}

.rating span:hover{
  color: var(--yellow);
}

/* The container <div> - needed to position the dropdown content */
.dropdown {
  position: relative;
  display: inline-block;
}

/* Dropdown Content (Hidden by Default) */
.dropdown-content {
  visibility: hidden;
  opacity: 0;
  position: absolute;
  background-color: #17181d;
  min-width: 260px;
  box-shadow: 0px 8px 16px 0px rgb(0 0 0 / 20%);
  z-index: 10000;
  top: calc(100% + 0.5rem);
  left: 0;
  width: 300px;
  max-height: 70vh;
  overflow: scroll;
  border-radius: 12px;
  transition: opacity .3s ease, visibility .3s ease;
}

.dropdown-content.active{
  visibility: visible;
  opacity: 1;
}

/* Links inside the dropdown */
.dropdown-content a {
  color: black;
  padding: 12px 16px;
  text-decoration: none;
  display: block;
}

/* Change color of dropdown links on hover */
.dropdown-content a:hover {background-color: #ddd;}

/* Show the dropdown menu (use JS to add this class to the .dropdown-content container when the user clicks on the dropdown button) */
.show {display:block;}

@media (max-width: 1200px){
  .filter-bar {
    flex-wrap: nowrap;
    justify-content: flex-start;
  }
}

@media (max-width: 600px){
  .dropdown-content {
    position: fixed;
    left: 0;
    right: 0;
    bottom: 0;
    width: 100%;
    max-width: none;
    margin: 0;
    border-top-left-radius: 18px;
    border-top-right-radius: 18px;
    border-bottom-left-radius: 0px;
    border-bottom-right-radius: 0px;
    top: auto;
    padding-bottom: max(env(safe-area-inset-bottom, 0px) + 1rem, 1.5rem);
    transform: translateY(100%);
    transition: transform 0.3s ease, opacity 0.3s ease;
  }

  .dropdown-content.active {
    transform: translateY(0);
    opacity: 1;
  }

  .filter-bar{
    width: 100%;
    justify-content: start;
  }

  .mobile-nav-trail {
    width: 100%;
  }
}

@media (max-width: 420px){
  .trail-map-buttons{
    margin-top: 1.5em;
  }
}

/* Vue Slider Custom Styles - Override defaults to prevent double rendering */
.vue-slider {
  /* Ensure single rail rendering */
  position: relative;
  box-sizing: border-box;
}

.vue-slider-rail {
  background-color: #8f8d8d;
  height: 4px !important;
  border-radius: 2px;
  /* Prevent pseudo elements that might cause double lines */
  &::before,
  &::after {
    display: none !important;
  }
}

.vue-slider-process {
  background-color: var(--yellow);
  height: 4px !important;
  border-radius: 2px;
  /* Ensure it's above the rail */
  position: absolute;
  z-index: 1;
}

.vue-slider-dot {
  background-color: var(--yellow);
  border: 2px solid var(--yellow);
  height: 12px;
  width: 12px;
  border-radius: 50%;
  /* Ensure proper positioning */
  z-index: 2;
}

.vue-slider-dot-handle {
  /* Remove any box shadows that might create visual artifacts */
  box-shadow: none !important;
  cursor: grab;
  &:active {
    cursor: grabbing;
  }
}

/* Remove any marks or additional elements that might cause double lines */
.vue-slider-mark,
.vue-slider-mark-step {
  display: none !important;
}

</style>
